import todoimg from "../images/todoproject.png";
import valimg from "../images/valproject.png";
import pokeimg from "../images/pokemonimg.png";

const projects = [
  {
    id: 1,
    name: "To-Do-App",
    url: "https://alforoan-todoapp.netlify.app/",
    imgURL: todoimg,
  },
  {
    id: 2,
    name: "GameInfo App",
    url: "https://alforoan-valorantapp.netlify.app/",
    imgURL: valimg,
  },
  {
    id: 3,
    name: "Pokemon Cards",
    url: "https://alforoan-pokemoncardsfinal.netlify.app/",
    imgURL: pokeimg,
  },
];

export default projects;
